/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import NoResultsImage from '../../assets/rovo-conversation-prompt-cards/no-results.svg';

import { messages } from './messages';

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		textAlign: 'center',
		gap: token('space.100'),
		paddingBlock: token('space.100'),
	},
	icon: {
		display: 'flex',
		justifyContent: 'center',
	},
});

export type PromptCardsEmptyStateProps = {
	/** Optional custom title message. Defaults to "No results found" */
	title?: string;
	/** Optional custom subtitle message. Defaults to "Try removing your filters and searching again" */
	subtitle?: string;
};

/**
 * Empty state component for the Prompt Cards Grid.
 * Displays when no prompts match the current filters.
 */
export const PromptCardsEmptyState = ({
	title,
	subtitle,
}: PromptCardsEmptyStateProps): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.container}>
			<Box xcss={styles.icon}>
				<Image src={NoResultsImage} alt="" />
			</Box>
			<Text weight="bold" size="large" as="p">
				{title || formatMessage(messages.noResultsTitle)}
			</Text>
			<Text color="color.text.subtle" size="medium" as="p">
				{subtitle || formatMessage(messages.noResultsSubtitle)}
			</Text>
		</Box>
	);
};
